import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { API_URLS } from "./../../urls";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import provinces from "./provinces";

export default function RegistrationForm() {
  const [isRequestSuccessful, setIsRequestSuccessful] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const [isLoading, setIsLoading] = useState(false);
  const [province, setProvince] = useState("");
  const [county, setCounty] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [position, setPosition] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const isButtonDisabled =
    !firstName ||
    !lastName ||
    !nationalId ||
    !phoneNumber ||
    !province ||
    !county ||
    !position ||
    !password ||
    !email ||
    !confirmPassword;

  const onSubmit = async (data) => {
    if (isButtonDisabled) return;

    setIsLoading(true);
    const payload = {
      name: data.firstName,
      family_name: data.lastName,
      national_code: nationalId,
      phone_number: phoneNumber,
      province_name: province,
      county_name: county,
      organ_position: position,
      password: password,
      email: email,
    };

    try {
      const response = await axios.post(
        `${API_URLS.BASE_URL}auth/register`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setIsLoading(false);
      setIsRequestSuccessful(true);
      setTimeout(() => {
        setIsRequestSuccessful(false);
      }, 3000);
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
      alert("خطا در ثبت‌نام. لطفاً دوباره تلاش کنید.");
    }
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

  return (
    <div className='flex flex-col items-center w-full'>
      <img src='images/logo-bime.svg' alt='' className='mb-5' />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className='w-[90%] md:w-[70%] p-6 pt-0 rounded-lg'
      >
        <div className='flex flex-wrap md:flex-nowrap gap-4 mb-4'>
          <div className='w-full md:w-1/2'>
            <label className='text-primary block text-sm mb-2'>نام:</label>
            <input
              value={firstName}
              {...register("firstName", {
                required: "وارد کردن نام ضروری است.",
              })}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.firstName ? "border-red-500" : "border-primary"
              }`}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[\u0600-\u06FF\s]*$/.test(value)) {
                  setFirstName(value);
                }
              }}
            />
            {errors.firstName && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.firstName.message}
              </p>
            )}
          </div>

          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>
              نام خانوادگی:
            </label>
            <input
              value={lastName}
              {...register("lastName", {
                required: "وارد کردن نام خانوادگی ضروری است.",
              })}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.lastName ? "border-red-500" : "border-primary"
              }`}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[\u0600-\u06FF\s]*$/.test(value)) {
                  setLastName(value);
                }
              }}
            />
            {errors.lastName && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.lastName.message}
              </p>
            )}
          </div>
        </div>

        <div className='flex flex-wrap md:flex-nowrap gap-4 mb-4'>
          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>کد ملی:</label>
            <input
              id='nationalId'
              type='text'
              maxLength={10}
              value={nationalId}
              {...register("nationalId", {
                required: "وارد کردن کدملی ضروری است.",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "کد ملی باید 10 رقم باشد.",
                },
              })}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setNationalId(value);
                }
              }}
              className={`w-full py-2 border rounded-[40px] px-3 text-gray-600 ${
                errors.nationalId ? "border-red-500" : "border-primary"
              }`}
            />
            {errors.nationalId && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.nationalId.message}
              </p>
            )}
          </div>

          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>
              سمت سازمانی:
            </label>
            <input
              {...register("position", {
                required: "وارد کردن سمت سازمانی ضروری است.",
              })}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.position ? "border-red-500" : "border-primary"
              }`}
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            />
            {errors.position && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.position.message}
              </p>
            )}
          </div>
        </div>

        <div className='flex flex-wrap md:flex-nowrap gap-4 mb-4'>
          <div className='flex flex-col w-full md:w-1/2'>
            <label htmlFor='province' className='text-primary text-sm mb-1'>
              استان
            </label>
            <select
              id='province'
              value={province}
              {...register("province", {
                required: "وارد کردن استان ضروری است.",
              })}
              onChange={(e) => setProvince(e.target.value)}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.province ? "border-red-500" : "border-primary"
              }`}
            >
              <option value='' disabled>
                انتخاب کنید
              </option>
              {provinces.map((province, index) => (
                <option key={index} value={province}>
                  {province}
                </option>
              ))}
            </select>

            {errors.province && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.province.message}
              </p>
            )}
          </div>
          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>شهرستان:</label>
            <input
              {...register("county", {
                required: "وارد کردن شهرستان ضروری است.",
              })}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.county ? "border-red-500" : "border-primary"
              }`}
              value={county}
              onChange={(e) => setCounty(e.target.value)}
            />
          </div>
        </div>

        <div className='flex flex-wrap md:flex-nowrap gap-4 mb-4'>
          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>
              شماره تلفن همراه:
            </label>
            <input
              id='phoneNumber'
              type='text'
              {...register("phoneNumber", {
                required: "وارد کردن شماره تلفن همراه ضروری است.",
                pattern: {
                  value: /^09\d{9}$/,
                  message: "شماره تلفن باید با ۰۹ شروع شود.",
                },
              })}
              maxLength={11}
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && value.length <= 11) {
                  setPhoneNumber(value);
                }
              }}
              className={`w-full px-3 py-2 border rounded-[40px] ${
                errors.phoneNumber ? "border-red-500" : "border-primary"
              }`}
            />
            {errors.phoneNumber && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.phoneNumber.message}
              </p>
            )}
          </div>

          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>ایمیل:</label>
            <input
              id='email'
              type='email'
              {...register("email", { required: "وارد کردن ایمیل ضروری است." })}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full py-2 border rounded-[40px] px-3 text-gray-600 ${
                errors.email ? "border-red-500" : "border-primary"
              }`}
            />
            {errors.email && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.email.message}
              </p>
            )}
          </div>
        </div>

        <div className='flex flex-wrap md:flex-nowrap gap-4 mb-4'>
          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>رمز عبور:</label>
            <div className='relative'>
              <input
                id='password'
                type={showPassword ? "text" : "password"}
                value={password}
                {...register("password", {
                  required: "وارد کردن رمز عبور ضروری است.",
                  pattern: {
                    value: passwordRegex,
                    message:
                      "رمز عبور باید شامل حداقل ۸ کاراکتر، یک حرف بزرگ، یک حرف کوچک و یک عدد باشد.",
                  },
                })}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full py-2 border rounded-[40px] px-3 text-gray-600 ${
                  errors.password ? "border-red-500" : "border-primary"
                }`}
              />
              <button
                type='button'
                className='absolute top-1/2 transform -translate-y-1/2 left-3'
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.password && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.password.message}
              </p>
            )}
          </div>

          <div className='w-full md:w-1/2'>
            <label className='block text-primary text-sm mb-2'>
              تکرار رمز عبور:
            </label>
            <div className='relative'>
              <input
                id='confirmPassword'
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                {...register("confirmPassword", {
                  required: "تکرار رمز عبور ضروری است.",
                  validate: (value) =>
                    value === password || "رمز عبور‌ها باید یکسان باشند.",
                })}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={`w-full py-2 border rounded-[40px] px-3 text-gray-600 ${
                  errors.confirmPassword ? "border-red-500" : "border-primary"
                }`}
              />
              <button
                type='button'
                className='absolute top-1/2 transform -translate-y-1/2 left-3'
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.confirmPassword && (
              <p className='text-red-500 text-xs mt-1'>
                {errors.confirmPassword.message}
              </p>
            )}
          </div>
        </div>

        <button
          type='submit'
          disabled={isButtonDisabled || isLoading}
          className={`w-full ${
            isButtonDisabled && !isLoading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-primary"
          } text-white rounded-[40px] border-none py-3 mt-1 flex items-center  cursor-not-allowed justify-center ${
            isLoading ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          {isLoading ? (
            <div className='w-5 h-5 animate-bounce'>ثبت‌نام</div>
          ) : (
            <p>ثبت‌نام</p>
          )}
        </button>
      </form>
      {isRequestSuccessful && (
        <div className='fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50'>
          <div className='bg-white p-10 rounded-md text-center flex flex-col items-center'>
            <p className='text-secondary text-[20px]'>
              فعال سازی حساب کاربری از طریق پیامک به اطلاع شما خواهد رسید.{" "}
            </p>
            <img src='images/Check-mark-circle.svg' alt='' />
          </div>
        </div>
      )}
    </div>
  );
}
